"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Justify = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var config_context_1 = require("../_util/config-context");
exports.Justify = react_1.forwardRef(function Justify(_a, ref) {
    var _b;
    var left = _a.left, right = _a.right, top = _a.top, bottom = _a.bottom, className = _a.className, props = tslib_1.__rest(_a, ["left", "right", "top", "bottom", "className"]);
    var classPrefix = config_context_1.useConfig().classPrefix;
    return (react_1.default.createElement("div", tslib_1.__assign({ ref: ref, className: classnames_1.default(classPrefix + "-justify-grid", className, (_b = {},
            _b[classPrefix + "-justify-grid--start"] = top,
            _b[classPrefix + "-justify-grid--end"] = bottom,
            _b)) }, props),
        left != null && (react_1.default.createElement("div", { className: classPrefix + "-justify-grid__col " + classPrefix + "-justify-grid__col--left" }, left)),
        right != null && (react_1.default.createElement("div", { className: classPrefix + "-justify-grid__col " + classPrefix + "-justify-grid__col--right" }, right))));
});
exports.Justify.displayName = "Justify";
//# sourceMappingURL=Justify.js.map